module.exports = __webpack_public_path__ + "static/media/about2.840a4be6.jpg";